import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";

const RootLayout = () => {
  const location = useLocation();
  const isOrdersPage = location.pathname.includes("orders") || location.pathname.includes("acgtcard");

  return (
    <div className='flex flex-col h-screen'>
      <header>
        <Header />
      </header>
      <main className='flex-1 pb-20'>
        <Outlet />
      </main>
      <footer>{isOrdersPage ? <Footer extraMargin={"mb-[91px]"} /> : <Footer />}</footer>
    </div>
  );
};

export default RootLayout;
